import React from 'react'
import { Drawer, Loader } from 'packages/eid-ui'
import ItemHeader from '../ItemHeader'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import { useManagementRole, useTargetPerson } from 'hooks'
import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ManagementRoleDetails from './ManagementRoleDetails'

const ManagementRoleDrawer = ({ id, toggleDrawer, attributes }) => {
    const isSmallScreen = useIsSmallScreen()
    const [targetPerson] = useTargetPerson()

    const { data } = useManagementRole(id, targetPerson.id)
    const managementRole = data?.resource
    const assignmentStatus = data?.assignment

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={managementRole?.localizedFriendlyName} />
            {!managementRole && <Loader />}
            {managementRole && (
                <ManagementRoleDetails
                    toggleDrawer={toggleDrawer}
                    attributes={attributes}
                    managementRole={managementRole}
                    assignmentStatus={assignmentStatus}
                />
            )}
        </ItemsDetailsMobileWrapper>
    ) : (
        <Drawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            header={
                <ItemHeader title={managementRole?.localizedFriendlyName} />
            }
            closeOnOutsideClick
        >
            {!managementRole && <Loader />}
            {managementRole && (
                <ManagementRoleDetails
                    toggleDrawer={toggleDrawer}
                    attributes={attributes}
                    managementRole={managementRole}
                    assignmentStatus={assignmentStatus}
                />
            )}
        </Drawer>
    )
}

export default ManagementRoleDrawer
